import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import { HashLink as Link } from 'react-router-hash-link';

// Browsers ignore control characters and whitespace in URLs ("java\tscript:" is "javascript:").
// eslint-disable-next-line no-control-regex
const normalizeHref = (href) => (typeof href === 'string' ? href.replace(/[\u0000- ]/g, '') : '');

const isExternalHref = (href) => /^(https?:|mailto:|tel:)/i.test(href);

// Internal links must be same-site paths or anchors: no "//host" or "\host" (open redirect).
const isInternalHref = (href) => /^[/#]/.test(href) && !/^[/\\]{2}/.test(href) && !href.includes('\\');

const options = {
    replace: (domNode) => {
        if (domNode.type !== 'tag' || domNode.name !== 'a') {
            return;
        }
        const href = normalizeHref(domNode.attribs.href);
        const children = domToReact(domNode.children, options);

        if (isInternalHref(href) && domNode.attribs.target !== '_blank') {
            return <Link to={href}>{children}</Link>;
        }
        if (isExternalHref(href)) {
            return domNode.attribs.target === '_blank'
                ? <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
                : <a href={href}>{children}</a>;
        }
        // Anything else (javascript:, data:, relative paths...) is rendered as plain text.
        return <>{children}</>;
    }
};

const ParserLink = ({ rendered }) => parse(rendered, options);

export default ParserLink;
